export default "__VITE_ASSET__fa59f6e2__"